import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { whatsappLink } from "@/config/site";

const features = [
  "Ensino baseado na metodologia Cambridge",
  "Preparação para exames Cambridge oficiais",
  "Inglês internacional, do A1 ao C2",
  "Desenvolvimento de competências linguísticas reais",
  "Preparação académica internacional",
  "Materiais alinhados com o padrão Cambridge",
];

export const Cambridge = () => {
  return (
    <section id="cambridge" data-testid="cambridge-section" className="relative section bg-navy-700 overflow-hidden">
      <div aria-hidden className="absolute inset-0 opacity-[0.07]" style={{
        backgroundImage: 'radial-gradient(circle at 20% 30%, white 1px, transparent 1px)',
        backgroundSize: '32px 32px',
      }} />
      <div aria-hidden className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-bordeaux-700/30 blur-3xl" />

      <div className="container-tight relative">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-white text-xs font-semibold uppercase tracking-[0.22em]">
              Metodologia Cambridge
            </div>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05]">
              Inglês com método <span className="italic text-bordeaux-200">Cambridge.</span>
            </h2>
            <p className="mt-6 text-white/75 leading-relaxed text-lg max-w-xl">
              No iLg, ensinamos inglês com base na metodologia Cambridge e preparamos os nossos alunos
              para os exames internacionais — desde os primeiros níveis até ao C2 Proficiency.
            </p>

            <ul className="mt-9 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {features.map((f) => (
                <li key={f} className="flex items-start gap-2.5 text-white/90 text-sm">
                  <CheckCircle2 size={18} className="text-bordeaux-200 mt-0.5 shrink-0" strokeWidth={1.5} />
                  <span>{f}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cambridge-whatsapp-btn"
                className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-white text-navy-700 font-semibold hover:bg-bordeaux-50 transition-all hover:-translate-y-0.5"
              >
                Saber mais sobre Cambridge
              </a>
              <a
                href="#contacto"
                data-testid="cambridge-contact-btn"
                className="inline-flex items-center justify-center px-7 py-3.5 rounded-full border border-white/30 text-white font-semibold hover:bg-white/10 transition-all"
              >
                Pedir avaliação gratuita
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] shadow-[0_40px_80px_rgba(0,0,0,0.4)]">
              <img
                src="https://images.pexels.com/photos/31390421/pexels-photo-31390421.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=720"
                alt="Biblioteca premium — preparação Cambridge"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur rounded-2xl p-5">
                <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-bordeaux-700">Níveis preparados</div>
                <div className="mt-2 flex flex-wrap gap-2">
                  {["A1 Starters", "A2 Flyers", "B1 PET", "B2 FCE", "C1 CAE", "C2 CPE"].map((lv) => (
                    <span key={lv} className="text-xs font-medium px-3 py-1 rounded-full bg-navy-700 text-white">{lv}</span>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
